import { IDominioResponseQA } from "../../interfaces/dados-pessoais/dominio-qa-response.interface";

export const LISTA_OPCAO_ORGAO_EMISSOR: IDominioResponseQA =
{
    "codigo_dominio": 13,
    "nome_dominio": "ORGAO EMISSOR DOCUMENTO",
    "descricao_conceito_dominio": "E CADA ORGAO PUBLICO QUE EMITE AOS CIDADAOS DOCUMENTOS COMO CARTEIRA DE IDENTIDADE (RG), PASSAPORTE, CPF (CADASTRO DE PESSOA FISICA), ETC. CADA DOCUMENTO E EMITIDO POR UM ORGAO GOVERNAMENTAL AUTORIZAD",
    "nome_referencia_dominio": "COD_ORGO_EMIO_DOCM",
    "headers": null,
    "valores_dominio": [
        {
            "codigo_valor_dominio": 176,
            "codigo_referencia_valor_dominio": "000000176",
            "nome_resumido_valor_dominio": "ABEXCON",
            "nome_completo_valor_dominio": "ABEXCON",
            "descricao_conceito_valor_dominio": "ASSOCIACAO BRASILEIRA DE EX-CONGRESSISTAS"
        },
        {
            "codigo_valor_dominio": 177,
            "codigo_referencia_valor_dominio": "000000177",
            "nome_resumido_valor_dominio": "ADGU",
            "nome_completo_valor_dominio": "ADGU",
            "descricao_conceito_valor_dominio": "ADVOCACIA GERAL DA UNIAO"
        },
        {
            "codigo_valor_dominio": 178,
            "codigo_referencia_valor_dominio": "000000178",
            "nome_resumido_valor_dominio": "AERON",
            "nome_completo_valor_dominio": "AERON",
            "descricao_conceito_valor_dominio": "MINISTERIO DA AERONAUTICA"
        },
        {
            "codigo_valor_dominio": 179,
            "codigo_referencia_valor_dominio": "000000179",
            "nome_resumido_valor_dominio": "ASLEGIS",
            "nome_completo_valor_dominio": "ASLEGIS",
            "descricao_conceito_valor_dominio": "ASSEMBLEIA LEGISLATIVA"
        },
        {
            "codigo_valor_dominio": 180,
            "codigo_referencia_valor_dominio": "000000180",
            "nome_resumido_valor_dominio": "CBM",
            "nome_completo_valor_dominio": "CBM",
            "descricao_conceito_valor_dominio": "CORPO DE BOMBEIROS MILITAR"
        },
        {
            "codigo_valor_dominio": 181,
            "codigo_referencia_valor_dominio": "000000181",
            "nome_resumido_valor_dominio": "CFB",
            "nome_completo_valor_dominio": "CFB",
            "descricao_conceito_valor_dominio": "CONSELHO FEDERAL DE BIOLOGIA"
        },
        {
            "codigo_valor_dominio": 182,
            "codigo_referencia_valor_dominio": "000000182",
            "nome_resumido_valor_dominio": "CFP",
            "nome_completo_valor_dominio": "CFP",
            "descricao_conceito_valor_dominio": "CONSELHO FEDERAL DE PSICOLOGIA"
        },
        {
            "codigo_valor_dominio": 183,
            "codigo_referencia_valor_dominio": "000000183",
            "nome_resumido_valor_dominio": "CGJ",
            "nome_completo_valor_dominio": "CGJ",
            "descricao_conceito_valor_dominio": "CORREGEDORIA GERAL DA JUSTICA"
        },
        {
            "codigo_valor_dominio": 184,
            "codigo_referencia_valor_dominio": "000000184",
            "nome_resumido_valor_dominio": "CMRJ",
            "nome_completo_valor_dominio": "CMRJ",
            "descricao_conceito_valor_dominio": "CAMARA MUNICIPAL DO RIO DE JANEIRO"
        },
        {
            "codigo_valor_dominio": 185,
            "codigo_referencia_valor_dominio": "000000185",
            "nome_resumido_valor_dominio": "CNDL",
            "nome_completo_valor_dominio": "CNDL",
            "descricao_conceito_valor_dominio": "CONFEDERACAO NACIONAL DE DIRIGENTES DE LOGISTAS"
        },
        {
            "codigo_valor_dominio": 186,
            "codigo_referencia_valor_dominio": "000000186",
            "nome_resumido_valor_dominio": "CNE",
            "nome_completo_valor_dominio": "CNE",
            "descricao_conceito_valor_dominio": "CONSELHO NACIONAL DE ESTATISTICA"
        },
        {
            "codigo_valor_dominio": 187,
            "codigo_referencia_valor_dominio": "000000187",
            "nome_resumido_valor_dominio": "CNEN",
            "nome_completo_valor_dominio": "CNEN",
            "descricao_conceito_valor_dominio": "COMISSAO NACIONAL DE ENERGIA NUCLEAR"
        },
        {
            "codigo_valor_dominio": 188,
            "codigo_referencia_valor_dominio": "000000188",
            "nome_resumido_valor_dominio": "CONDEBR",
            "nome_completo_valor_dominio": "CONDEBR",
            "descricao_conceito_valor_dominio": "CONSELHO DOS DETETIVES DO BRASIL"
        },
        {
            "codigo_valor_dominio": 189,
            "codigo_referencia_valor_dominio": "000000189",
            "nome_resumido_valor_dominio": "CONFEV",
            "nome_completo_valor_dominio": "CONFEV",
            "descricao_conceito_valor_dominio": "CONSELHO FEDERAL DE MEDICINA VETERINARIA"
        },
        {
            "codigo_valor_dominio": 190,
            "codigo_referencia_valor_dominio": "000000190",
            "nome_resumido_valor_dominio": "CONRE",
            "nome_completo_valor_dominio": "CONRE",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE ESTATISTICA"
        },
        {
            "codigo_valor_dominio": 191,
            "codigo_referencia_valor_dominio": "000000191",
            "nome_resumido_valor_dominio": "CONRERP",
            "nome_completo_valor_dominio": "CONRERP",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DOS PROFISSIONAIS EM RELACOES PUBLICAS"
        },
        {
            "codigo_valor_dominio": 192,
            "codigo_referencia_valor_dominio": "000000192",
            "nome_resumido_valor_dominio": "CORE",
            "nome_completo_valor_dominio": "CORE",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DOS REPRESENTANTES COMERCIAIS"
        },
        {
            "codigo_valor_dominio": 193,
            "codigo_referencia_valor_dominio": "000000193",
            "nome_resumido_valor_dominio": "CORECON",
            "nome_completo_valor_dominio": "CORECON",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE ECONOMIA"
        },
        {
            "codigo_valor_dominio": 194,
            "codigo_referencia_valor_dominio": "000000194",
            "nome_resumido_valor_dominio": "COREM",
            "nome_completo_valor_dominio": "COREM",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE MUSEOLOGIA"
        },
        {
            "codigo_valor_dominio": 195,
            "codigo_referencia_valor_dominio": "000000195",
            "nome_resumido_valor_dominio": "COREN",
            "nome_completo_valor_dominio": "COREN",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE ENFERMAGEM"
        },
        {
            "codigo_valor_dominio": 196,
            "codigo_referencia_valor_dominio": "000000196",
            "nome_resumido_valor_dominio": "CRA",
            "nome_completo_valor_dominio": "CRA",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE ADMINISTRACAO"
        },
        {
            "codigo_valor_dominio": 197,
            "codigo_referencia_valor_dominio": "000000197",
            "nome_resumido_valor_dominio": "CRAS",
            "nome_completo_valor_dominio": "CRAS",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE ASSISTENTES SOCIAIS"
        },
        {
            "codigo_valor_dominio": 198,
            "codigo_referencia_valor_dominio": "000000198",
            "nome_resumido_valor_dominio": "CRB",
            "nome_completo_valor_dominio": "CRB",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE BIBLIOTECONOMIA OU BIOLOGIA"
        },
        {
            "codigo_valor_dominio": 199,
            "codigo_referencia_valor_dominio": "000000199",
            "nome_resumido_valor_dominio": "CRBM",
            "nome_completo_valor_dominio": "CRBM",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE BIOMEDICINA"
        },
        {
            "codigo_valor_dominio": 200,
            "codigo_referencia_valor_dominio": "000000200",
            "nome_resumido_valor_dominio": "CRC",
            "nome_completo_valor_dominio": "CRC",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE CONTABILIDADE"
        },
        {
            "codigo_valor_dominio": 201,
            "codigo_referencia_valor_dominio": "000000201",
            "nome_resumido_valor_dominio": "CRCPN",
            "nome_completo_valor_dominio": "CRCPN",
            "descricao_conceito_valor_dominio": "CARTORIO DE REGISTRO CIVIL DA PESSOAS NATURAIS"
        },
        {
            "codigo_valor_dominio": 202,
            "codigo_referencia_valor_dominio": "000000202",
            "nome_resumido_valor_dominio": "CRDD",
            "nome_completo_valor_dominio": "CRDD",
            "descricao_conceito_valor_dominio": "CONFEDERACAO REGIONAL DOS DESPACHANTES DOCUMENTALISTAS"
        },
        {
            "codigo_valor_dominio": 203,
            "codigo_referencia_valor_dominio": "000000203",
            "nome_resumido_valor_dominio": "CREA",
            "nome_completo_valor_dominio": "CREA",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL/FEDERAL DE ENGENHARIA, ARQUITETURA E AGRONOMIA"
        },
        {
            "codigo_valor_dominio": 204,
            "codigo_referencia_valor_dominio": "000000204",
            "nome_resumido_valor_dominio": "CRECI",
            "nome_completo_valor_dominio": "CRECI",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DOS CORRETORES DE IMOVEIS"
        },
        {
            "codigo_valor_dominio": 205,
            "codigo_referencia_valor_dominio": "000000205",
            "nome_resumido_valor_dominio": "CREF",
            "nome_completo_valor_dominio": "CREF",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE EDUCACAO FISICA"
        },
        {
            "codigo_valor_dominio": 206,
            "codigo_referencia_valor_dominio": "000000206",
            "nome_resumido_valor_dominio": "CREFITO",
            "nome_completo_valor_dominio": "CREFITO",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL"
        },
        {
            "codigo_valor_dominio": 207,
            "codigo_referencia_valor_dominio": "000000207",
            "nome_resumido_valor_dominio": "CRESS",
            "nome_completo_valor_dominio": "CRESS",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE SERVICO SOCIAL"
        },
        {
            "codigo_valor_dominio": 208,
            "codigo_referencia_valor_dominio": "000000208",
            "nome_resumido_valor_dominio": "CRF",
            "nome_completo_valor_dominio": "CRF",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE FARMACIA"
        },
        {
            "codigo_valor_dominio": 209,
            "codigo_referencia_valor_dominio": "000000209",
            "nome_resumido_valor_dominio": "CRFA",
            "nome_completo_valor_dominio": "CRFA",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE FONOAUDIOLOGIA"
        },
        {
            "codigo_valor_dominio": 210,
            "codigo_referencia_valor_dominio": "000000210",
            "nome_resumido_valor_dominio": "CRM",
            "nome_completo_valor_dominio": "CRM",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE MEDICINA"
        },
        {
            "codigo_valor_dominio": 211,
            "codigo_referencia_valor_dominio": "000000211",
            "nome_resumido_valor_dominio": "CRMV",
            "nome_completo_valor_dominio": "CRMV",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE MEDICINA VETERINARIA"
        },
        {
            "codigo_valor_dominio": 212,
            "codigo_referencia_valor_dominio": "000000212",
            "nome_resumido_valor_dominio": "CRN",
            "nome_completo_valor_dominio": "CRN",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE NUTRICIONISTAS"
        },
        {
            "codigo_valor_dominio": 213,
            "codigo_referencia_valor_dominio": "000000213",
            "nome_resumido_valor_dominio": "CRO",
            "nome_completo_valor_dominio": "CRO",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL/FEDERAL DE ODONTOLOGIA"
        },
        {
            "codigo_valor_dominio": 214,
            "codigo_referencia_valor_dominio": "000000214",
            "nome_resumido_valor_dominio": "CRP",
            "nome_completo_valor_dominio": "CRP",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE PSICOLOGIA"
        },
        {
            "codigo_valor_dominio": 215,
            "codigo_referencia_valor_dominio": "000000215",
            "nome_resumido_valor_dominio": "CRQ",
            "nome_completo_valor_dominio": "CRQ",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE QUIMICA"
        },
        {
            "codigo_valor_dominio": 216,
            "codigo_referencia_valor_dominio": "000000216",
            "nome_resumido_valor_dominio": "CRTA",
            "nome_completo_valor_dominio": "CRTA",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE TECNICOS DE ADMINISTRACAO"
        },
        {
            "codigo_valor_dominio": 217,
            "codigo_referencia_valor_dominio": "000000217",
            "nome_resumido_valor_dominio": "CRTR",
            "nome_completo_valor_dominio": "CRTR",
            "descricao_conceito_valor_dominio": "CONSELHO REGIONAL DE TECNICOS EM RADIOLOGIA"
        },
        {
            "codigo_valor_dominio": 218,
            "codigo_referencia_valor_dominio": "000000218",
            "nome_resumido_valor_dominio": "CTMTB",
            "nome_completo_valor_dominio": "CTMTB",
            "descricao_conceito_valor_dominio": "MINISTERIO DO TRABALHO - DELEGACIA REGIONAL DO TRABALHO"
        },
        {
            "codigo_valor_dominio": 219,
            "codigo_referencia_valor_dominio": "000000219",
            "nome_resumido_valor_dominio": "DEF",
            "nome_completo_valor_dominio": "DEF",
            "descricao_conceito_valor_dominio": "MINISTERIO DA DEFESA"
        },
        {
            "codigo_valor_dominio": 220,
            "codigo_referencia_valor_dominio": "000000220",
            "nome_resumido_valor_dominio": "DEPCT",
            "nome_completo_valor_dominio": "DEPCT",
            "descricao_conceito_valor_dominio": "DEPARTAMENTO DE CORREIOS E TELEGRAFOS"
        },
        {
            "codigo_valor_dominio": 221,
            "codigo_referencia_valor_dominio": "000000221",
            "nome_resumido_valor_dominio": "DESIPE",
            "nome_completo_valor_dominio": "DESIPE",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DE JUSTICA E INTERIOR"
        },
        {
            "codigo_valor_dominio": 222,
            "codigo_referencia_valor_dominio": "000000222",
            "nome_resumido_valor_dominio": "DESP",
            "nome_completo_valor_dominio": "DESP",
            "descricao_conceito_valor_dominio": "DEPARTAMENTO ESTADUAL DE SEGURANCA PUBLICA"
        },
        {
            "codigo_valor_dominio": 223,
            "codigo_referencia_valor_dominio": "000000223",
            "nome_resumido_valor_dominio": "DETRAN",
            "nome_completo_valor_dominio": "DETRAN",
            "descricao_conceito_valor_dominio": "DEPARTAMENTO DE TRANSITO"
        },
        {
            "codigo_valor_dominio": 224,
            "codigo_referencia_valor_dominio": "000000224",
            "nome_resumido_valor_dominio": "DFSP",
            "nome_completo_valor_dominio": "DFSP",
            "descricao_conceito_valor_dominio": "DEPARTAMENTO FEDERAL DE SEGURANCA PUBLICA"
        },
        {
            "codigo_valor_dominio": 225,
            "codigo_referencia_valor_dominio": "000000225",
            "nome_resumido_valor_dominio": "DGPC",
            "nome_completo_valor_dominio": "DGPC",
            "descricao_conceito_valor_dominio": "DIRETORIA GERAL DA POLICIA CIVIL"
        },
        {
            "codigo_valor_dominio": 226,
            "codigo_referencia_valor_dominio": "000000226",
            "nome_resumido_valor_dominio": "DI",
            "nome_completo_valor_dominio": "DI",
            "descricao_conceito_valor_dominio": "DEPARTAMENTO DE INVESTIGACOES"
        },
        {
            "codigo_valor_dominio": 227,
            "codigo_referencia_valor_dominio": "000000227",
            "nome_resumido_valor_dominio": "DIEM",
            "nome_completo_valor_dominio": "DIEM",
            "descricao_conceito_valor_dominio": "DIRETORIA DE IDENTIFICACAO ENEAS MARTINS"
        },
        {
            "codigo_valor_dominio": 230,
            "codigo_referencia_valor_dominio": "000000230",
            "nome_resumido_valor_dominio": "DPC",
            "nome_completo_valor_dominio": "DPC",
            "descricao_conceito_valor_dominio": "DEPARTAMENTO DA POLICIA CIVIL"
        },
        {
            "codigo_valor_dominio": 231,
            "codigo_referencia_valor_dominio": "000000231",
            "nome_resumido_valor_dominio": "DPGE",
            "nome_completo_valor_dominio": "DPGE",
            "descricao_conceito_valor_dominio": "DEFENSORIA PUBLICA GERAL DO ESTADO"
        },
        {
            "codigo_valor_dominio": 232,
            "codigo_referencia_valor_dominio": "000000232",
            "nome_resumido_valor_dominio": "DPTC",
            "nome_completo_valor_dominio": "DPTC",
            "descricao_conceito_valor_dominio": "DEPTO DE POLICIA TECNICO CIENTIFICA"
        },
        {
            "codigo_valor_dominio": 233,
            "codigo_referencia_valor_dominio": "000000233",
            "nome_resumido_valor_dominio": "DSG",
            "nome_completo_valor_dominio": "DSG",
            "descricao_conceito_valor_dominio": "DIVISAO DE SEGURANCA E GUARDA"
        },
        {
            "codigo_valor_dominio": 234,
            "codigo_referencia_valor_dominio": "000000234",
            "nome_resumido_valor_dominio": "EAPJU",
            "nome_completo_valor_dominio": "EAPJU",
            "descricao_conceito_valor_dominio": "ESTADO DO AMAZONAS PODER JUDICIARIO"
        },
        {
            "codigo_valor_dominio": 235,
            "codigo_referencia_valor_dominio": "000000235",
            "nome_resumido_valor_dominio": "ESG",
            "nome_completo_valor_dominio": "ESG",
            "descricao_conceito_valor_dominio": "ESCOLA SUPERIOR DE GUERRA"
        },
        {
            "codigo_valor_dominio": 236,
            "codigo_referencia_valor_dominio": "000000236",
            "nome_resumido_valor_dominio": "EXERCIT",
            "nome_completo_valor_dominio": "EXERCIT",
            "descricao_conceito_valor_dominio": "MINISTERIO DO EXERCITO"
        },
        {
            "codigo_valor_dominio": 237,
            "codigo_referencia_valor_dominio": "000000237",
            "nome_resumido_valor_dominio": "FENAJ",
            "nome_completo_valor_dominio": "FENAJ",
            "descricao_conceito_valor_dominio": "FEDERACAO NACIONAL DOS JORNALISTAS PROFISSIONAIS"
        },
        {
            "codigo_valor_dominio": 238,
            "codigo_referencia_valor_dominio": "000000238",
            "nome_resumido_valor_dominio": "FUNAI",
            "nome_completo_valor_dominio": "FUNAI",
            "descricao_conceito_valor_dominio": "FUNDACAO NACIONAL DO INDIO"
        },
        {
            "codigo_valor_dominio": 239,
            "codigo_referencia_valor_dominio": "000000239",
            "nome_resumido_valor_dominio": "GEJ",
            "nome_completo_valor_dominio": "GEJ",
            "descricao_conceito_valor_dominio": "GERENCIA ESTADO DE JUSTICA"
        },
        {
            "codigo_valor_dominio": 240,
            "codigo_referencia_valor_dominio": "000000240",
            "nome_resumido_valor_dominio": "GEJSPC",
            "nome_completo_valor_dominio": "GEJSPC",
            "descricao_conceito_valor_dominio": "GERENCIA DE ESTADO DE JUSTICA, SEGURANCA PUBLICA E CIDADANIA"
        },
        {
            "codigo_valor_dominio": 241,
            "codigo_referencia_valor_dominio": "000000241",
            "nome_resumido_valor_dominio": "GISI",
            "nome_completo_valor_dominio": "GISI",
            "descricao_conceito_valor_dominio": "GABINETE DE INVESTIGACOES SERVICO DE IDENTIFICACAO"
        },
        {
            "codigo_valor_dominio": 242,
            "codigo_referencia_valor_dominio": "000000242",
            "nome_resumido_valor_dominio": "IC",
            "nome_completo_valor_dominio": "IC",
            "descricao_conceito_valor_dominio": "INSTITUTO DE CRIMINOLOGIA"
        },
        {
            "codigo_valor_dominio": 243,
            "codigo_referencia_valor_dominio": "000000243",
            "nome_resumido_valor_dominio": "ID",
            "nome_completo_valor_dominio": "ID",
            "descricao_conceito_valor_dominio": "INSTITUTO DE IDENTIFICACAO"
        },
        {
            "codigo_valor_dominio": 244,
            "codigo_referencia_valor_dominio": "000000244",
            "nome_resumido_valor_dominio": "IFP",
            "nome_completo_valor_dominio": "IFP",
            "descricao_conceito_valor_dominio": "INSTITUTO FELIX PACHECO/INSTITUTO DE IDENTIFICACAO FELIX PACHECO"
        },
        {
            "codigo_valor_dominio": 245,
            "codigo_referencia_valor_dominio": "000000245",
            "nome_resumido_valor_dominio": "IGP",
            "nome_completo_valor_dominio": "IGP",
            "descricao_conceito_valor_dominio": "INSTITUTO GERAL DE PERICIA"
        },
        {
            "codigo_valor_dominio": 246,
            "codigo_referencia_valor_dominio": "000000246",
            "nome_resumido_valor_dominio": "IICM",
            "nome_completo_valor_dominio": "IICM",
            "descricao_conceito_valor_dominio": "INSTITUTO DE IDENTIFICACAO CARLOS MENEZES"
        },
        {
            "codigo_valor_dominio": 247,
            "codigo_referencia_valor_dominio": "000000247",
            "nome_resumido_valor_dominio": "IIDAMP",
            "nome_completo_valor_dominio": "IIDAMP",
            "descricao_conceito_valor_dominio": "INSTITUTO DE IDENTIFICACAO DR. AROLDO MENDES DE PAIVA"
        },
        {
            "codigo_valor_dominio": 248,
            "codigo_referencia_valor_dominio": "000000248",
            "nome_resumido_valor_dominio": "IIDML",
            "nome_completo_valor_dominio": "IIDML",
            "descricao_conceito_valor_dominio": "INSTITUTO DE IDENTIFICACAO MEDICO LEGAL"
        },
        {
            "codigo_valor_dominio": 249,
            "codigo_referencia_valor_dominio": "000000249",
            "nome_resumido_valor_dominio": "IIEP",
            "nome_completo_valor_dominio": "IIEP",
            "descricao_conceito_valor_dominio": "INSTITUTO DE IDENTIFICACAO DO ESTADO DO PARANA"
        },
        {
            "codigo_valor_dominio": 250,
            "codigo_referencia_valor_dominio": "000000250",
            "nome_resumido_valor_dominio": "IIMPS",
            "nome_completo_valor_dominio": "IIMPS",
            "descricao_conceito_valor_dominio": "INSTITUTO DE IDENTIFICACAO DEL MARIO PEDRO DOS SANTOS"
        },
        {
            "codigo_valor_dominio": 251,
            "codigo_referencia_valor_dominio": "000000251",
            "nome_resumido_valor_dominio": "IIRGD",
            "nome_completo_valor_dominio": "IIRGD",
            "descricao_conceito_valor_dominio": "INSTITUTO DE IDENTIFICACAO RICARDO GUMBLETON DAUNT"
        },
        {
            "codigo_valor_dominio": 252,
            "codigo_referencia_valor_dominio": "000000252",
            "nome_resumido_valor_dominio": "IITP",
            "nome_completo_valor_dominio": "IITP",
            "descricao_conceito_valor_dominio": "INSTITUTO DE IDENTIFICACAO TECNICA POLICIAL"
        },
        {
            "codigo_valor_dominio": 253,
            "codigo_referencia_valor_dominio": "000000253",
            "nome_resumido_valor_dominio": "IMLC",
            "nome_completo_valor_dominio": "IMLC",
            "descricao_conceito_valor_dominio": "INSTITUTO DE MEDICINA LEGAL E CRIMINALISTICA"
        },
        {
            "codigo_valor_dominio": 254,
            "codigo_referencia_valor_dominio": "000000254",
            "nome_resumido_valor_dominio": "INI",
            "nome_completo_valor_dominio": "INI",
            "descricao_conceito_valor_dominio": "INSTITUTO NACIONAL DE IDENTIFICACAO"
        },
        {
            "codigo_valor_dominio": 255,
            "codigo_referencia_valor_dominio": "000000255",
            "nome_resumido_valor_dominio": "INVALIDO",
            "nome_completo_valor_dominio": "INVALIDO",
            "descricao_conceito_valor_dominio": "INVALIDO"
        },
        {
            "codigo_valor_dominio": 256,
            "codigo_referencia_valor_dominio": "000000256",
            "nome_resumido_valor_dominio": "IPF",
            "nome_completo_valor_dominio": "IPF",
            "descricao_conceito_valor_dominio": "INSTITUTO PEREIRA FAUSTINO"
        },
        {
            "codigo_valor_dominio": 257,
            "codigo_referencia_valor_dominio": "000000257",
            "nome_resumido_valor_dominio": "IPT",
            "nome_completo_valor_dominio": "IPT",
            "descricao_conceito_valor_dominio": "INSTITUTO DE POLICIA TECNICA"
        },
        {
            "codigo_valor_dominio": 258,
            "codigo_referencia_valor_dominio": "000000258",
            "nome_resumido_valor_dominio": "ITB",
            "nome_completo_valor_dominio": "ITB",
            "descricao_conceito_valor_dominio": "INSTITUTO TAVARES BURIL/INSTITUTO DE IDENTIFICACAO TAVARES BURIL"
        },
        {
            "codigo_valor_dominio": 259,
            "codigo_referencia_valor_dominio": "000000259",
            "nome_resumido_valor_dominio": "JUIJ",
            "nome_completo_valor_dominio": "JUIJ",
            "descricao_conceito_valor_dominio": "JUIZADO DA INFANCIA E DA JUVENTUDE"
        },
        {
            "codigo_valor_dominio": 260,
            "codigo_referencia_valor_dominio": "000000260",
            "nome_resumido_valor_dominio": "LAISSEZ",
            "nome_completo_valor_dominio": "LAISSEZ",
            "descricao_conceito_valor_dominio": "AGENCIA ESPECIALIZADA DA ONU - ORGANIZACAO DAS NACOES UNIDAS"
        },
        {
            "codigo_valor_dominio": 261,
            "codigo_referencia_valor_dominio": "000000261",
            "nome_resumido_valor_dominio": "MARINHA",
            "nome_completo_valor_dominio": "MARINHA",
            "descricao_conceito_valor_dominio": "MINISTERIO DA MARINHA"
        },
        {
            "codigo_valor_dominio": 262,
            "codigo_referencia_valor_dominio": "000000262",
            "nome_resumido_valor_dominio": "MC",
            "nome_completo_valor_dominio": "MC",
            "descricao_conceito_valor_dominio": "MINISTERIO DAS COMUNICACOES"
        },
        {
            "codigo_valor_dominio": 263,
            "codigo_referencia_valor_dominio": "000000263",
            "nome_resumido_valor_dominio": "MCT",
            "nome_completo_valor_dominio": "MCT",
            "descricao_conceito_valor_dominio": "MINISTERIO DA CIENCIA E TECNOLOGIA"
        },
        {
            "codigo_valor_dominio": 264,
            "codigo_referencia_valor_dominio": "000000264",
            "nome_resumido_valor_dominio": "MCU",
            "nome_completo_valor_dominio": "MCU",
            "descricao_conceito_valor_dominio": "MINISTERIO DA CULTURA"
        },
        {
            "codigo_valor_dominio": 265,
            "codigo_referencia_valor_dominio": "000000265",
            "nome_resumido_valor_dominio": "MEC",
            "nome_completo_valor_dominio": "MEC",
            "descricao_conceito_valor_dominio": "MINISTERIO DA EDUCACAO E CULTURA - MEC"
        },
        {
            "codigo_valor_dominio": 266,
            "codigo_referencia_valor_dominio": "000000266",
            "nome_resumido_valor_dominio": "MED",
            "nome_completo_valor_dominio": "MED",
            "descricao_conceito_valor_dominio": "MINISTERIO DA EDUCACAO E DO DESPORTO"
        },
        {
            "codigo_valor_dominio": 267,
            "codigo_referencia_valor_dominio": "000000267",
            "nome_resumido_valor_dominio": "MEFP",
            "nome_completo_valor_dominio": "MEFP",
            "descricao_conceito_valor_dominio": "MINISTERIO DA ECONOMIA, FAZENDA E PLANEJAMENTO"
        },
        {
            "codigo_valor_dominio": 268,
            "codigo_referencia_valor_dominio": "000000268",
            "nome_resumido_valor_dominio": "MEUF",
            "nome_completo_valor_dominio": "MEUF",
            "descricao_conceito_valor_dominio": "MINISTERIO DA EDUCACAO - UNIVERSIDADE FEDERAL"
        },
        {
            "codigo_valor_dominio": 269,
            "codigo_referencia_valor_dominio": "000000269",
            "nome_resumido_valor_dominio": "MF",
            "nome_completo_valor_dominio": "MF",
            "descricao_conceito_valor_dominio": "MINISTERIO DA FAZENDA"
        },
        {
            "codigo_valor_dominio": 270,
            "codigo_referencia_valor_dominio": "000000270",
            "nome_resumido_valor_dominio": "MGUERRA",
            "nome_completo_valor_dominio": "MGUERRA",
            "descricao_conceito_valor_dominio": "MINISTERIO DA GUERRA"
        },
        {
            "codigo_valor_dominio": 271,
            "codigo_referencia_valor_dominio": "000000271",
            "nome_resumido_valor_dominio": "MI",
            "nome_completo_valor_dominio": "MI",
            "descricao_conceito_valor_dominio": "MINISTERIO DO INTERIOR"
        },
        {
            "codigo_valor_dominio": 272,
            "codigo_referencia_valor_dominio": "000000272",
            "nome_resumido_valor_dominio": "MIC",
            "nome_completo_valor_dominio": "MIC",
            "descricao_conceito_valor_dominio": "MINISTERIO DA INDUSTRIA E COMERCIO"
        },
        {
            "codigo_valor_dominio": 273,
            "codigo_referencia_valor_dominio": "000000273",
            "nome_resumido_valor_dominio": "MJ",
            "nome_completo_valor_dominio": "MJ",
            "descricao_conceito_valor_dominio": "MINISTERIO DA JUSTICA"
        },
        {
            "codigo_valor_dominio": 274,
            "codigo_referencia_valor_dominio": "000000274",
            "nome_resumido_valor_dominio": "MPAS",
            "nome_completo_valor_dominio": "MPAS",
            "descricao_conceito_valor_dominio": "MINISTERIO DA PREVIDENCIA E ASSISTENCIA SOCIAL"
        },
        {
            "codigo_valor_dominio": 275,
            "codigo_referencia_valor_dominio": "000000275",
            "nome_resumido_valor_dominio": "MPBA",
            "nome_completo_valor_dominio": "MPBA",
            "descricao_conceito_valor_dominio": "MINISTERIO PUBLICO DA BAHIA"
        },
        {
            "codigo_valor_dominio": 276,
            "codigo_referencia_valor_dominio": "000000276",
            "nome_resumido_valor_dominio": "MPDFT",
            "nome_completo_valor_dominio": "MPDFT",
            "descricao_conceito_valor_dominio": "MINISTERIO PUBLICO DO DISTRITO FEDERAL E TERRITORIOS"
        },
        {
            "codigo_valor_dominio": 277,
            "codigo_referencia_valor_dominio": "000000277",
            "nome_resumido_valor_dominio": "MPEMG",
            "nome_completo_valor_dominio": "MPEMG",
            "descricao_conceito_valor_dominio": "MINISTERIO PUBLICO DO ESTADO DE MINAS GERAIS"
        },
        {
            "codigo_valor_dominio": 278,
            "codigo_referencia_valor_dominio": "000000278",
            "nome_resumido_valor_dominio": "MPEMT",
            "nome_completo_valor_dominio": "MPEMT",
            "descricao_conceito_valor_dominio": "MINISTERIO PUBLICO DO ESTADO DE MATO GROSSO"
        },
        {
            "codigo_valor_dominio": 279,
            "codigo_referencia_valor_dominio": "000000279",
            "nome_resumido_valor_dominio": "MPEPR",
            "nome_completo_valor_dominio": "MPEPR",
            "descricao_conceito_valor_dominio": "MINISTERIO PUBLICO DO ESTADO DO PARANA"
        },
        {
            "codigo_valor_dominio": 280,
            "codigo_referencia_valor_dominio": "000000280",
            "nome_resumido_valor_dominio": "MPERJ",
            "nome_completo_valor_dominio": "MPERJ",
            "descricao_conceito_valor_dominio": "MINISTERIO PUBLICO DO ESTADO DO RIO DE JANEIRO"
        },
        {
            "codigo_valor_dominio": 281,
            "codigo_referencia_valor_dominio": "000000281",
            "nome_resumido_valor_dominio": "MPESP",
            "nome_completo_valor_dominio": "MPESP",
            "descricao_conceito_valor_dominio": "MINISTERIO PUBLICO DO ESTADO DE SAO PAULO"
        },
        {
            "codigo_valor_dominio": 282,
            "codigo_referencia_valor_dominio": "000000282",
            "nome_resumido_valor_dominio": "MPF",
            "nome_completo_valor_dominio": "MPF",
            "descricao_conceito_valor_dominio": "MINISTERIO PUBLICO FEDERAL"
        },
        {
            "codigo_valor_dominio": 283,
            "codigo_referencia_valor_dominio": "000000283",
            "nome_resumido_valor_dominio": "MPM",
            "nome_completo_valor_dominio": "MPM",
            "descricao_conceito_valor_dominio": "MINISTERIO PUBLICO MILITAR"
        },
        {
            "codigo_valor_dominio": 284,
            "codigo_referencia_valor_dominio": "000000284",
            "nome_resumido_valor_dominio": "MPT",
            "nome_completo_valor_dominio": "MPT",
            "descricao_conceito_valor_dominio": "MINISTERIO PUBLICO DO TRABALHO"
        },
        {
            "codigo_valor_dominio": 285,
            "codigo_referencia_valor_dominio": "000000285",
            "nome_resumido_valor_dominio": "MRE",
            "nome_completo_valor_dominio": "MRE",
            "descricao_conceito_valor_dominio": "MINISTERIO DAS RELACOES EXTERIORES"
        },
        {
            "codigo_valor_dominio": 286,
            "codigo_referencia_valor_dominio": "000000286",
            "nome_resumido_valor_dominio": "MS",
            "nome_completo_valor_dominio": "MS",
            "descricao_conceito_valor_dominio": "MINISTERIO DA SAUDE"
        },
        {
            "codigo_valor_dominio": 287,
            "codigo_referencia_valor_dominio": "000000287",
            "nome_resumido_valor_dominio": "MT",
            "nome_completo_valor_dominio": "MT",
            "descricao_conceito_valor_dominio": "MINISTERIO DO TRABALHO"
        },
        {
            "codigo_valor_dominio": 288,
            "codigo_referencia_valor_dominio": "000000288",
            "nome_resumido_valor_dominio": "MTRANSP",
            "nome_completo_valor_dominio": "MTRANSP",
            "descricao_conceito_valor_dominio": "MINISTERIO DOS TRANSPORTES"
        },
        {
            "codigo_valor_dominio": 289,
            "codigo_referencia_valor_dominio": "000000289",
            "nome_resumido_valor_dominio": "OAB",
            "nome_completo_valor_dominio": "OAB",
            "descricao_conceito_valor_dominio": "ORDEM DOS ADVOGADOS DO BRASIL"
        },
        {
            "codigo_valor_dominio": 290,
            "codigo_referencia_valor_dominio": "000000290",
            "nome_resumido_valor_dominio": "OMBCR",
            "nome_completo_valor_dominio": "OMBCR",
            "descricao_conceito_valor_dominio": "ORDEM DOS MUSICOS/CONSELHO REGIONAL"
        },
        {
            "codigo_valor_dominio": 291,
            "codigo_referencia_valor_dominio": "000000291",
            "nome_resumido_valor_dominio": "PASSPOR",
            "nome_completo_valor_dominio": "PASSPOR",
            "descricao_conceito_valor_dominio": "PAIS DE ORIGEM"
        },
        {
            "codigo_valor_dominio": 292,
            "codigo_referencia_valor_dominio": "000000292",
            "nome_resumido_valor_dominio": "PCIID",
            "nome_completo_valor_dominio": "PCIID",
            "descricao_conceito_valor_dominio": "POLICIA CIVIL INSTITUTO DE IDENTIFICACAO"
        },
        {
            "codigo_valor_dominio": 293,
            "codigo_referencia_valor_dominio": "000000293",
            "nome_resumido_valor_dominio": "PCMG",
            "nome_completo_valor_dominio": "PCMG",
            "descricao_conceito_valor_dominio": "POLICIA CIVIL DE MINAS GERAIS"
        },
        {
            "codigo_valor_dominio": 294,
            "codigo_referencia_valor_dominio": "000000294",
            "nome_resumido_valor_dominio": "PCRJ",
            "nome_completo_valor_dominio": "PCRJ",
            "descricao_conceito_valor_dominio": "PREFEITURA DA CIDADE DO RIO DE JANEIRO"
        },
        {
            "codigo_valor_dominio": 295,
            "codigo_referencia_valor_dominio": "000000295",
            "nome_resumido_valor_dominio": "PDFII",
            "nome_completo_valor_dominio": "PDFII",
            "descricao_conceito_valor_dominio": "POLICIA DO DISTRITO FEDERAL - INSTITUTO DE IDENTIFICACAO"
        },
        {
            "codigo_valor_dominio": 296,
            "codigo_referencia_valor_dominio": "000000296",
            "nome_resumido_valor_dominio": "PFF",
            "nome_completo_valor_dominio": "PFF",
            "descricao_conceito_valor_dominio": "POLICIA FERROVIARIA FEDERAL"
        },
        {
            "codigo_valor_dominio": 297,
            "codigo_referencia_valor_dominio": "000000297",
            "nome_resumido_valor_dominio": "PGE",
            "nome_completo_valor_dominio": "PGE",
            "descricao_conceito_valor_dominio": "PROCURADORIA GERAL DO ESTADO"
        },
        {
            "codigo_valor_dominio": 298,
            "codigo_referencia_valor_dominio": "000000298",
            "nome_resumido_valor_dominio": "PGJ",
            "nome_completo_valor_dominio": "PGJ",
            "descricao_conceito_valor_dominio": "PROCURADORIA GERAL DE JUSTICA"
        },
        {
            "codigo_valor_dominio": 299,
            "codigo_referencia_valor_dominio": "000000299",
            "nome_resumido_valor_dominio": "PIG",
            "nome_completo_valor_dominio": "PIG",
            "descricao_conceito_valor_dominio": "PENITENCIARIA INDUSTRIAL DE GUARAPUAVA"
        },
        {
            "codigo_valor_dominio": 300,
            "codigo_referencia_valor_dominio": "000000300",
            "nome_resumido_valor_dominio": "PJEG",
            "nome_completo_valor_dominio": "PJEG",
            "descricao_conceito_valor_dominio": "PODER JUDICIARIO DO ESTADO DE GOIAS"
        },
        {
            "codigo_valor_dominio": 301,
            "codigo_referencia_valor_dominio": "000000301",
            "nome_resumido_valor_dominio": "PJERJ",
            "nome_completo_valor_dominio": "PJERJ",
            "descricao_conceito_valor_dominio": "PODER JUDICIARIO DO ESTADO DO RIO DE JANEIRO"
        },
        {
            "codigo_valor_dominio": 302,
            "codigo_referencia_valor_dominio": "000000302",
            "nome_resumido_valor_dominio": "PLM",
            "nome_completo_valor_dominio": "PLM",
            "descricao_conceito_valor_dominio": "PODER LEGISLATIVO MUNICIPAL"
        },
        {
            "codigo_valor_dominio": 303,
            "codigo_referencia_valor_dominio": "000000303",
            "nome_resumido_valor_dominio": "PM",
            "nome_completo_valor_dominio": "PM",
            "descricao_conceito_valor_dominio": "POLICIA MILITAR ESTADUAL"
        },
        {
            "codigo_valor_dominio": 304,
            "codigo_referencia_valor_dominio": "000000304",
            "nome_resumido_valor_dominio": "PMP",
            "nome_completo_valor_dominio": "PMP",
            "descricao_conceito_valor_dominio": "PREFEITURA MUNICIPAL DE PETROPOLIS"
        },
        {
            "codigo_valor_dominio": 305,
            "codigo_referencia_valor_dominio": "000000305",
            "nome_resumido_valor_dominio": "PTC",
            "nome_completo_valor_dominio": "PTC",
            "descricao_conceito_valor_dominio": "POLICIA TECNICO CIENTIFICA"
        },
        {
            "codigo_valor_dominio": 306,
            "codigo_referencia_valor_dominio": "000000306",
            "nome_resumido_valor_dominio": "RBR",
            "nome_completo_valor_dominio": "RBR",
            "descricao_conceito_valor_dominio": "REPUBLICA DO BRASIL"
        },
        {
            "codigo_valor_dominio": 307,
            "codigo_referencia_valor_dominio": "000000307",
            "nome_resumido_valor_dominio": "RFBR",
            "nome_completo_valor_dominio": "RFBR",
            "descricao_conceito_valor_dominio": "REPUBLICA FEDERATIVA DO BRASIL"
        },
        {
            "codigo_valor_dominio": 308,
            "codigo_referencia_valor_dominio": "000000308",
            "nome_resumido_valor_dominio": "RFF",
            "nome_completo_valor_dominio": "RFF",
            "descricao_conceito_valor_dominio": "REDE FERROVIARIA FEDERAL"
        },
        {
            "codigo_valor_dominio": 309,
            "codigo_referencia_valor_dominio": "000000309",
            "nome_resumido_valor_dominio": "SADGP",
            "nome_completo_valor_dominio": "SADGP",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ADIMINISTRACAO - DEPARTAMENTO GERAL PESSOAL"
        },
        {
            "codigo_valor_dominio": 310,
            "codigo_referencia_valor_dominio": "000000310",
            "nome_resumido_valor_dominio": "SAPESS",
            "nome_completo_valor_dominio": "SAPESS",
            "descricao_conceito_valor_dominio": "SUPERINTENDENCIA DE ADMINISTRACAO DE PESSOAL"
        },
        {
            "codigo_valor_dominio": 311,
            "codigo_referencia_valor_dominio": "000000311",
            "nome_resumido_valor_dominio": "SC",
            "nome_completo_valor_dominio": "SC",
            "descricao_conceito_valor_dominio": "SECRETARIA DA CULTURA"
        },
        {
            "codigo_valor_dominio": 312,
            "codigo_referencia_valor_dominio": "000000312",
            "nome_resumido_valor_dominio": "SCJDS",
            "nome_completo_valor_dominio": "SCJDS",
            "descricao_conceito_valor_dominio": "SECRETARIA COORDENADORA DE JUSTICA E DEFESA SOCIAL"
        },
        {
            "codigo_valor_dominio": 313,
            "codigo_referencia_valor_dominio": "000000313",
            "nome_resumido_valor_dominio": "SEA",
            "nome_completo_valor_dominio": "SEA",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DE ADMINISTRACAO"
        },
        {
            "codigo_valor_dominio": 314,
            "codigo_referencia_valor_dominio": "000000314",
            "nome_resumido_valor_dominio": "SECC",
            "nome_completo_valor_dominio": "SECC",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DA CASA CIVIL"
        },
        {
            "codigo_valor_dominio": 315,
            "codigo_referencia_valor_dominio": "000000315",
            "nome_resumido_valor_dominio": "SECT",
            "nome_completo_valor_dominio": "SECT",
            "descricao_conceito_valor_dominio": "SECRETARIA ESPECIAL DE CIENCIA E TECNOLOGIA"
        },
        {
            "codigo_valor_dominio": 316,
            "codigo_referencia_valor_dominio": "000000316",
            "nome_resumido_valor_dominio": "SEDPF",
            "nome_completo_valor_dominio": "SEDPF",
            "descricao_conceito_valor_dominio": "SERVICO DE ESTRANGEIROS-DEPTO POLICIA MARITIMA, AEREA E DE FRONTEIRA-DEPTO DE POLICIA FEDERAL-CIMCRE/CGPMAF"
        },
        {
            "codigo_valor_dominio": 317,
            "codigo_referencia_valor_dominio": "000000317",
            "nome_resumido_valor_dominio": "SEDS",
            "nome_completo_valor_dominio": "SEDS",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DA DEFESA SOCIAL"
        },
        {
            "codigo_valor_dominio": 318,
            "codigo_referencia_valor_dominio": "000000318",
            "nome_resumido_valor_dominio": "SEEC",
            "nome_completo_valor_dominio": "SEEC",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DE EDUCACAO E CULTURA"
        },
        {
            "codigo_valor_dominio": 319,
            "codigo_referencia_valor_dominio": "000000319",
            "nome_resumido_valor_dominio": "SEF",
            "nome_completo_valor_dominio": "SEF",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DE FAZENDA"
        },
        {
            "codigo_valor_dominio": 320,
            "codigo_referencia_valor_dominio": "000000320",
            "nome_resumido_valor_dominio": "SEJSP",
            "nome_completo_valor_dominio": "SEJSP",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DA JUSTICA E SEGURANCA PUBLICA"
        },
        {
            "codigo_valor_dominio": 321,
            "codigo_referencia_valor_dominio": "000000321",
            "nome_resumido_valor_dominio": "SEJU",
            "nome_completo_valor_dominio": "SEJU",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DA JUSTICA"
        },
        {
            "codigo_valor_dominio": 322,
            "codigo_referencia_valor_dominio": "000000322",
            "nome_resumido_valor_dominio": "SEOMA",
            "nome_completo_valor_dominio": "SEOMA",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DE OBRAS E MEIO AMBIENTE"
        },
        {
            "codigo_valor_dominio": 323,
            "codigo_referencia_valor_dominio": "000000323",
            "nome_resumido_valor_dominio": "SEPC",
            "nome_completo_valor_dominio": "SEPC",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DA POLICIA CIVIL"
        },
        {
            "codigo_valor_dominio": 324,
            "codigo_referencia_valor_dominio": "000000324",
            "nome_resumido_valor_dominio": "SES",
            "nome_completo_valor_dominio": "SES",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DA SEGURANCA"
        },
        {
            "codigo_valor_dominio": 325,
            "codigo_referencia_valor_dominio": "000000325",
            "nome_resumido_valor_dominio": "SESDC",
            "nome_completo_valor_dominio": "SESDC",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DE SEGURANCA DEFESA E CIDADANIA"
        },
        {
            "codigo_valor_dominio": 326,
            "codigo_referencia_valor_dominio": "000000326",
            "nome_resumido_valor_dominio": "SESP",
            "nome_completo_valor_dominio": "SESP",
            "descricao_conceito_valor_dominio": "SECRETARIA DO ESTADO DE SEGURANCA PUBLICA"
        },
        {
            "codigo_valor_dominio": 327,
            "codigo_referencia_valor_dominio": "000000327",
            "nome_resumido_valor_dominio": "SESPDC",
            "nome_completo_valor_dominio": "SESPDC",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DA SEGURANCA PUBLICA E DEFESA DO CIDADAO"
        },
        {
            "codigo_valor_dominio": 328,
            "codigo_referencia_valor_dominio": "000000328",
            "nome_resumido_valor_dominio": "SESPDS",
            "nome_completo_valor_dominio": "SESPDS",
            "descricao_conceito_valor_dominio": "SECRETARIA DE ESTADO DE SEGURANCA PUBLICA E DEFESA SOCIAL"
        },
        {
            "codigo_valor_dominio": 329,
            "codigo_referencia_valor_dominio": "000000329",
            "nome_resumido_valor_dominio": "SF",
            "nome_completo_valor_dominio": "SF",
            "descricao_conceito_valor_dominio": "SENADO FEDERAL"
        },
        {
            "codigo_valor_dominio": 330,
            "codigo_referencia_valor_dominio": "000000330",
            "nome_resumido_valor_dominio": "SGPJ",
            "nome_completo_valor_dominio": "SGPJ",
            "descricao_conceito_valor_dominio": "SUPERINTENDENCIA GERAL DE POLICIA JUDICIARIA"
        },
        {
            "codigo_valor_dominio": 331,
            "codigo_referencia_valor_dominio": "000000331",
            "nome_resumido_valor_dominio": "SI",
            "nome_completo_valor_dominio": "SI",
            "descricao_conceito_valor_dominio": "SERVICO DE IDENTIFICACAO"
        },
        {
            "codigo_valor_dominio": 332,
            "codigo_referencia_valor_dominio": "000000332",
            "nome_resumido_valor_dominio": "SIC",
            "nome_completo_valor_dominio": "SIC",
            "descricao_conceito_valor_dominio": "SERVICO DE IDENTIFICACAO E CRIMINALISTICA"
        },
        {
            "codigo_valor_dominio": 333,
            "codigo_referencia_valor_dominio": "000000333",
            "nome_resumido_valor_dominio": "SIJ",
            "nome_completo_valor_dominio": "SIJ",
            "descricao_conceito_valor_dominio": "SECRETARIA DO INTERIOR DA JUSTICA"
        },
        {
            "codigo_valor_dominio": 334,
            "codigo_referencia_valor_dominio": "000000334",
            "nome_resumido_valor_dominio": "SJDS",
            "nome_completo_valor_dominio": "SJDS",
            "descricao_conceito_valor_dominio": "SECRETARIA DE JUSTICA E DEFESA SOCIAL"
        },
        {
            "codigo_valor_dominio": 335,
            "codigo_referencia_valor_dominio": "000000335",
            "nome_resumido_valor_dominio": "SJIS",
            "nome_completo_valor_dominio": "SJIS",
            "descricao_conceito_valor_dominio": "SECRETARIA DE JUSTICA, INTERIOR E SEGURANCA"
        },
        {
            "codigo_valor_dominio": 336,
            "codigo_referencia_valor_dominio": "000000336",
            "nome_resumido_valor_dominio": "SJP",
            "nome_completo_valor_dominio": "SJP",
            "descricao_conceito_valor_dominio": "SINDICATO DOS JORNALISTAS PROFISSIONAIS"
        },
        {
            "codigo_valor_dominio": 337,
            "codigo_referencia_valor_dominio": "000000337",
            "nome_resumido_valor_dominio": "SJS",
            "nome_completo_valor_dominio": "SJS",
            "descricao_conceito_valor_dominio": "SECRETARIA DA JUSTICA E DA SEGURANCA"
        },
        {
            "codigo_valor_dominio": 338,
            "codigo_referencia_valor_dominio": "000000338",
            "nome_resumido_valor_dominio": "SJSP",
            "nome_completo_valor_dominio": "SJSP",
            "descricao_conceito_valor_dominio": "SECRETARIA DE JUSTICA E SEGURANCA PUBLICA"
        },
        {
            "codigo_valor_dominio": 339,
            "codigo_referencia_valor_dominio": "000000339",
            "nome_resumido_valor_dominio": "SJTC",
            "nome_completo_valor_dominio": "SJTC",
            "descricao_conceito_valor_dominio": "SECRETARIA DA JUSTICA DO TRABALHO E CIDADANIA"
        },
        {
            "codigo_valor_dominio": 340,
            "codigo_referencia_valor_dominio": "000000340",
            "nome_resumido_valor_dominio": "SPC",
            "nome_completo_valor_dominio": "SPC",
            "descricao_conceito_valor_dominio": "SUPERINTENDENCIA DE POLICIA CIVIL"
        },
        {
            "codigo_valor_dominio": 341,
            "codigo_referencia_valor_dominio": "000000341",
            "nome_resumido_valor_dominio": "SPCII",
            "nome_completo_valor_dominio": "SPCII",
            "descricao_conceito_valor_dominio": "SEGURANCA PUBLICA E CIDADANIA INSTITUTO DE IDENTIFICACAO"
        },
        {
            "codigo_valor_dominio": 342,
            "codigo_referencia_valor_dominio": "000000342",
            "nome_resumido_valor_dominio": "SPSP",
            "nome_completo_valor_dominio": "SPSP",
            "descricao_conceito_valor_dominio": "SECRETARIA DE POLICIA E SEGURANCA PUBLICA"
        },
        {
            "codigo_valor_dominio": 343,
            "codigo_referencia_valor_dominio": "000000343",
            "nome_resumido_valor_dominio": "SPTC",
            "nome_completo_valor_dominio": "SPTC",
            "descricao_conceito_valor_dominio": "SUPERINTENDENCIA DE POLICIA TECNICO CIENTIFICA"
        },
        {
            "codigo_valor_dominio": 344,
            "codigo_referencia_valor_dominio": "000000344",
            "nome_resumido_valor_dominio": "SRF",
            "nome_completo_valor_dominio": "SRF",
            "descricao_conceito_valor_dominio": "SECRETARIA DA RECEITA FEDERAL"
        },
        {
            "codigo_valor_dominio": 345,
            "codigo_referencia_valor_dominio": "000000345",
            "nome_resumido_valor_dominio": "SSDS",
            "nome_completo_valor_dominio": "SSDS",
            "descricao_conceito_valor_dominio": "SECRETARIA DA SEGURANCA E DA DEFESA SOCIAL"
        },
        {
            "codigo_valor_dominio": 346,
            "codigo_referencia_valor_dominio": "000000346",
            "nome_resumido_valor_dominio": "SSI",
            "nome_completo_valor_dominio": "SSI",
            "descricao_conceito_valor_dominio": "SECRETARIA DE SEGURANCA E INFORMACOES"
        },
        {
            "codigo_valor_dominio": 347,
            "codigo_referencia_valor_dominio": "000000347",
            "nome_resumido_valor_dominio": "SSP",
            "nome_completo_valor_dominio": "SSP",
            "descricao_conceito_valor_dominio": "SECRETARIA DE/DA SEGURANCA PUBLICA"
        },
        {
            "codigo_valor_dominio": 348,
            "codigo_referencia_valor_dominio": "000000348",
            "nome_resumido_valor_dominio": "SSPDC",
            "nome_completo_valor_dominio": "SSPDC",
            "descricao_conceito_valor_dominio": "SECRETARIA DA SEGURANCA PUBLICA E DEFESA DA CIDADANIA"
        },
        {
            "codigo_valor_dominio": 349,
            "codigo_referencia_valor_dominio": "000000349",
            "nome_resumido_valor_dominio": "SSPDS",
            "nome_completo_valor_dominio": "SSPDS",
            "descricao_conceito_valor_dominio": "SECRETARIA DA SEGURANCA PUBLICA E DEFESA SOCIAL"
        },
        {
            "codigo_valor_dominio": 350,
            "codigo_referencia_valor_dominio": "000000350",
            "nome_resumido_valor_dominio": "STM",
            "nome_completo_valor_dominio": "STM",
            "descricao_conceito_valor_dominio": "SUPERIOR TRIBUNAL MILITAR"
        },
        {
            "codigo_valor_dominio": 351,
            "codigo_referencia_valor_dominio": "000000351",
            "nome_resumido_valor_dominio": "TC",
            "nome_completo_valor_dominio": "TC",
            "descricao_conceito_valor_dominio": "TRIBUNAL DE CONTAS"
        },
        {
            "codigo_valor_dominio": 352,
            "codigo_referencia_valor_dominio": "000000352",
            "nome_resumido_valor_dominio": "TJ",
            "nome_completo_valor_dominio": "TJ",
            "descricao_conceito_valor_dominio": "TRIBUNAL DE JUSTICA"
        },
        {
            "codigo_valor_dominio": 353,
            "codigo_referencia_valor_dominio": "000000353",
            "nome_resumido_valor_dominio": "TRE",
            "nome_completo_valor_dominio": "TRE",
            "descricao_conceito_valor_dominio": "TRIBUNAL REGIONAL ELEITORAL"
        },
        {
            "codigo_valor_dominio": 354,
            "codigo_referencia_valor_dominio": "000000354",
            "nome_resumido_valor_dominio": "TRF",
            "nome_completo_valor_dominio": "TRF",
            "descricao_conceito_valor_dominio": "TRIBUNAL REGIONAL FEDERAL"
        },
        {
            "codigo_valor_dominio": 355,
            "codigo_referencia_valor_dominio": "000000355",
            "nome_resumido_valor_dominio": "TRFJA",
            "nome_completo_valor_dominio": "TRFJA",
            "descricao_conceito_valor_dominio": "TRIBUNAL REGIONAL FEDERAL DE JUSTICA ARBITRAL"
        },
        {
            "codigo_valor_dominio": 356,
            "codigo_referencia_valor_dominio": "000000356",
            "nome_resumido_valor_dominio": "TRIBALC",
            "nome_completo_valor_dominio": "TRIBALC",
            "descricao_conceito_valor_dominio": "TRIBUNAL DE ALCADA"
        },
        {
            "codigo_valor_dominio": 357,
            "codigo_referencia_valor_dominio": "000000357",
            "nome_resumido_valor_dominio": "TRT",
            "nome_completo_valor_dominio": "TRT",
            "descricao_conceito_valor_dominio": "TRIBUNAL REGIONAL DO TRABALHO"
        },
        {
            "codigo_valor_dominio": 358,
            "codigo_referencia_valor_dominio": "000000358",
            "nome_resumido_valor_dominio": "TST",
            "nome_completo_valor_dominio": "TST",
            "descricao_conceito_valor_dominio": "TRIBUNAL SUPERIOR DO TRABALHO"
        },
        {
            "codigo_valor_dominio": 359,
            "codigo_referencia_valor_dominio": "000000359",
            "nome_resumido_valor_dominio": "UFB",
            "nome_completo_valor_dominio": "UFB",
            "descricao_conceito_valor_dominio": "UNIVERSIDADE FEDERAL DA BAHIA"
        },
        {
            "codigo_valor_dominio": 12505,
            "codigo_referencia_valor_dominio": "000012505",
            "nome_resumido_valor_dominio": "DPF",
            "nome_completo_valor_dominio": "DEPARTAMENTO DE POLICIA FEDERAL",
            "descricao_conceito_valor_dominio": "DEPARTAMENTO DE POLICIA FEDERAL E O ORGAO RESPONSAVEL PELA EMISSAO DE PASSAPORTES"
        },
        {
            "codigo_valor_dominio": 12506,
            "codigo_referencia_valor_dominio": "000012506",
            "nome_resumido_valor_dominio": "DRT",
            "nome_completo_valor_dominio": "DELEGACIA REGIONAL DO TRABALHO",
            "descricao_conceito_valor_dominio": "A DELEGACIA REGIONAL DO TRABALHO (D.R.T.), DO MINISTERIO DO TRABALHO, INDUSTRIA E COMERCIO, A QUE SE REFERE O DECRETO-LEI N 2.168, DE 6 DE MAIO DE 1940, SAO DIRETAMENTE SUBORDINADAS AO MINISTRO DO TRABALHO, INDUSTRIA E COMERCIO E TEM POR FINALIDADE ORIENTAR, EXECUTAR E FISCALIZAR, NA ESFERA DE SUA JURISDICAO PROPRIA, O EXATO CUMPRIMENTO DAS LEIS DE PROTECAO DO TRABALHO, BEM ASSIM OUTROS ENCARGOS DE ORGAOS DO ALUDIDO MINISTERIO, QUE LHES SEJAM LEGALMENTE CONFERIDOS."
        },
        {
            "codigo_valor_dominio": 12507,
            "codigo_referencia_valor_dominio": "000012507",
            "nome_resumido_valor_dominio": "PC",
            "nome_completo_valor_dominio": "POLICIA CIVIL",
            "descricao_conceito_valor_dominio": "A POLICIA CIVIL E O ORGAO RESPONSAVEL PELA SEGURANCA PUBLICA, TENDO COMO FUNCOES PRINCIPAIS: PREVENIR, REPREENDER E INVESTIGAR CRIMES."
        },
        {
            "codigo_valor_dominio": 12508,
            "codigo_referencia_valor_dominio": "000012508",
            "nome_resumido_valor_dominio": "PF",
            "nome_completo_valor_dominio": "POLICIA FEDERAL",
            "descricao_conceito_valor_dominio": "POLICIA FEDERAL E O ORGAO RESPONSAVEL PELA EMISSAO DO DOCUMENTO FUNCIONAL DO POLICIAL FEDERAL"
        }
    ]
}